import angular from 'angular'

angular.module('pub.drop.edit', []).controller('DropEditCtrl', DropEditCtrl)

/** @ngInject */
function DropEditCtrl(
  $scope,
  $rootScope,
  $q,
  $stateParams,
  $location,
  $state,
  $sce,
  $timeout,
  UploadService,
  TranslatorService,
  ChannelsService,
  DropsService,
  SetsService,
  TranslationDropService,
  PublisherAdminService,
) {
  var vm = this
  vm.model = {}
  vm.loadT = false
  vm.loadH = false
  vm.loadHWeb = false
  vm.loadL = false
  vm.loadAd = false
  vm.loadVideo = false
  vm.date = null
  vm.loadAdWeb = false
  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.pathImgHWeb = ''
  vm.pathImgL = ''
  vm.pathImgAd = ''
  vm.pathVideoTrailer = ''
  vm.pathImgAdWeb = ''
  $('.button-dark').removeClass('is-active')
  $('.button-light').addClass('is-active')
  var edit = $location.$$path.indexOf('edit') !== -1

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  $('#setSelect').select2('data', [])

  vm.isOpen = false
  vm.openCalendarDate = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }
  vm.channels = []

  vm.dropTranslations = []
  function loadTranslations() {
    TranslationDropService.listTranslations($stateParams.id).then(function (result) {
      vm.dropTranslations = result.results
    })
  }

  ChannelsService.get().then(function (result) {
    vm.channels = result.results
  })

  PublisherAdminService.getPublisher().then(function (result) {
    vm.publishers = result.results
  })

  loadTranslations()

  vm.title = null

  if (edit) {
    vm.breadcrumb = 'product/drops/edit'
    DropsService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      vm.title = vm.model.t
      vm.description = vm.model.txt
      vm.pathImgT = vm.model['img-t']
      vm.pathImgH = vm.model['img-h']
      vm.pathImgHWeb = vm.model['img-h-web']
      vm.pathImgL = vm.model['img-l']
      vm.pathImgAd = vm.model['img-ad']

      vm.pathVideoTrailer = vm.model['vid-t'] === undefined ? '' : vm.model['vid-t']
      if (vm.pathVideoTrailer)
        vm.videoTrailer = $sce.trustAsResourceUrl(
          $rootScope.urlS3 + '/drops/' + vm.pathVideoTrailer,
        )

      vm.pathImgAdWeb = vm.model['img-ad-web']
      $('#setSelect').select2('data', vm.model.s)
      if (vm.model['ts-drp'] && vm.model['ts-drp'] !== 0) {
        vm.model['ts-drp'] = vm.model['ts-drp'] / 1000
        vm.model['ts-drp'] = new Date(parseInt(vm.model['ts-drp']))
        // set seconds to zero
        vm.model['ts-drp'].setSeconds(0)
        vm.date = angular.copy(vm.model['ts-drp'])
      } else if (vm.model['ts-drp'] === 0) {
        vm.model['ts-drp'] = null
        vm.date = null
      }

      if (vm.model['id-ch']) {
        vm.checklistOptions = [
          {
            id: 'clean_slate',
            name: 'Recollect',
          },
          {
            id: 'rank',
            name: 'Rank',
          },
        ]
      } else {
        vm.checklistOptions = [
          {
            id: 'clean_slate',
            name: 'Recollect',
          },
          {
            id: 'rank',
            name: 'Rank',
          },
          {
            id: 'hold',
            name: "Hold 'Em",
          },
        ]
      }
    })
  } else {
    vm.breadcrumb = 'product/drops/create'
  }

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       $state.go(route, { parentId: paramsId })
  //       return
  //     }
  //   }

  //   TranslatorService.translateDropAllLanguage(t, txt, null).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               TranslationDropService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt ? res.txt.results.zh : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               TranslationDropService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt ? res.txt.results.zh : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               TranslationDropService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt ? res.txt.results['zh-TW'] : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               TranslationDropService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt ? res.txt.results['zh-TW'] : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               TranslationDropService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt ? res.txt.results.ko : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               TranslationDropService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt ? res.txt.results.ko : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               TranslationDropService.createTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt ? res.txt.results.ja : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               TranslationDropService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt ? res.txt.results.ja : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           $state.go(route)
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           TranslationDropService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt ? res.txt.results.zh : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           TranslationDropService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt ? res.txt.results['zh-TW'] : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           TranslationDropService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt ? res.txt.results.ko : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           TranslationDropService.createTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt ? res.txt.results.ja : '',
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         $state.go(route)
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.save = function () {
    if (vm.date) {
      if (isDate(vm.date)) {
        var date = parseInt(new Date(new Date(vm.date).setSeconds(0)).getTime() * 1000)
        vm.model['ts-drp'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      vm.model['ts-drp'] = 0
    }

    const sets = $('#setSelect').select2('data')
    if (sets.length > 0 && vm.model['id-ch']) {
      swal('You can not select a set and a channel at the same time.', '', 'error')
      return
    }

    if (sets.length > 0) {
      vm.model['s'] = sets
    }

    if (edit) {
      DropsService.update($stateParams.id, vm.model).then(function (result) {
        if (sets.length > 0) {
          DropsService.saveSets($stateParams.id, sets).then(function () {
            // makeTranslation(
            //   vm.model.t,
            //   vm.model.txt,
            //   vm.dropTranslations,
            //   result.results.id,
            //   'pub.drops',
            // )
            $state.go('pub.drops')
          })
        } else {
          // makeTranslation(
          //   vm.model.t,
          //   vm.model.txt,
          //   vm.dropTranslations,
          //   result.results.id,
          //   'pub.drops',
          // )
          $state.go('pub.drops')
        }
      })
    } else {
      ChannelsService.save(vm.model).then(function (result) {
        if (sets.length > 0) {
          DropsService.saveSets($stateParams.id, sets).then(function () {
            // makeTranslation(
            //   vm.model.t,
            //   vm.model.txt,
            //   vm.dropTranslations,
            //   result.results.id,
            //   'pub.drops',
            // )
            $state.go('pub.drops')
          })
        } else {
          // makeTranslation(
          //   vm.model.t,
          //   vm.model.txt,
          //   vm.dropTranslations,
          //   result.results.id,
          //   'pub.drops',
          // )
          $state.go('pub.drops')
        }
      })
    }
  }

  var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT = false
      return
    }

    if (newVal === null) {
      vm.loadT = false
      return
    }

    vm.loadT = true
    UploadService.save('drops', newVal, 'img-t', $stateParams.id).then(function (fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
      vm.pathImgT = fileName
    })
  })

  var watch1 = $scope.$watch('vm.fileImgH', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadH = false
      return
    }

    if (newVal === null) {
      vm.loadH = false
      return
    }

    vm.loadH = true
    UploadService.save('drops', newVal, 'img-h', $stateParams.id).then(function (fileName) {
      vm.loadH = false
      vm.model['img-h'] = fileName
      vm.pathImgH = fileName
    })
  })

  var watch2 = $scope.$watch('vm.fileImgAd', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadAd = false
      return
    }

    if (newVal === null) {
      vm.loadAd = false
      return
    }

    vm.loadAd = true
    UploadService.save('drops', newVal, 'img-ad', $stateParams.id).then(function (fileName) {
      vm.loadAd = false
      vm.model['img-ad'] = fileName
      vm.pathImgAd = fileName
    })
  })

  var watch3 = $scope.$watch('vm.fileImgAdWeb', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadAdWeb = false
      return
    }

    if (newVal === null) {
      vm.loadAdWeb = false
      return
    }

    vm.loadAdWeb = true
    UploadService.save('drops', newVal, 'img-ad-web', $stateParams.id).then(function (fileName) {
      vm.loadAdWeb = false
      vm.model['img-ad-web'] = fileName
      vm.pathImgAdWeb = fileName
    })
  })

  var watch4 = $scope.$watch('vm.fileImgHWeb', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadHWeb = false
      return
    }

    if (newVal === null) {
      vm.loadHWeb = false
      return
    }

    vm.loadHWeb = true
    UploadService.save('drops', newVal, 'img-h-web', $stateParams.id).then(function (fileName) {
      vm.loadHWeb = false
      vm.model['img-h-web'] = fileName
      vm.pathImgHWeb = fileName
    })
  })

  var watch5 = $scope.$watch('vm.fileVideoTrailer', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadTrailer = false
      return
    }

    if (newVal === null) {
      vm.loadTrailer = false
      return
    }

    vm.loadTrailer = true
    UploadService.save('drops', newVal, 'vid-t', $stateParams.id).then(function (fileName) {
      vm.loadTrailer = false
      vm.model['vid-t'] = fileName
      vm.pathVideoTrailer = fileName
      vm.videoTrailer = $sce.trustAsResourceUrl($rootScope.urlS3 + '/drops/' + vm.pathVideoTrailer)
    })
  })

  var watch6 = $scope.$watch("vm.model['id-ch']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    vm.checklistOptions = [
      {
        id: 'clean_slate',
        name: 'Recollect',
      },
      {
        id: 'rank',
        name: 'Rank',
      },
    ]
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
    watch4()
    watch5()
  })

  vm.deleteImage = function (key) {
    switch (key) {
      case 'img-h':
        vm.pathImgH = ''
        vm.loadH = false
        break
      case 'img-h-web':
        vm.pathImgHWeb = ''
        vm.loadHWeb = false
        break
      case 'img-t':
        vm.pathImgT = ''
        vm.loadT = false
        break
      case 'img-ad':
        vm.pathImgAd = ''
        vm.loadAd = false
        break
      case 'img-ad-web':
        vm.pathImgAdWeb = ''
        vm.loadAdWeb = false
        break
      case 'trailer_video':
        vm.pathVideoTrailer = ''
        vm.videoTrailer = ''
        vm.loadTrailer = false
        break
    }
    vm.model[key] = ''
  }

  vm.cancel = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $state.go('pub.drops')
        }
      },
    )
  }

  vm.removeChannel = function () {
    vm.model['id-ch'] = null
  }

  vm.removeSet = function () {
    vm.model['s'] = null
    $('#setSelect').select2('data', [])
  }

  vm.checklistOptions = [
    {
      id: 'clean_slate',
      name: 'Recollect',
    },
    {
      id: 'rank',
      name: 'Rank',
    },
    {
      id: 'hold',
      name: "Hold 'Em",
    },
  ]

  vm.albumTypes = [
    {
      id: 'channel',
      name: 'Channel',
    },
    {
      id: 'sets',
      name: 'Set',
    },
    {
      id: 'awards',
      name: 'Award',
    },
  ]

  vm.isOpenChecklist1 = false
  vm.openCalendarChecklist1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist1 = true
  }

  vm.isOpenChecklist2 = false
  vm.openCalendarChecklist2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist2 = true
  }

  vm.isOpenChecklist3 = false
  vm.openCalendarChecklist3 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist3 = true
  }

  vm.isOpenChecklist4 = false
  vm.openCalendarChecklist4 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist4 = true
  }

  vm.isOpenDate = false
  vm.openCalendarDate = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenDate = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.valRankMin = ''
  vm.valRankMax = ''
  vm.createChecklist = function () {
    if (!vm.checklistOption) {
      swal('You must select a option', '', 'warninng')
      return
    }

    if (vm.checklistOption === 'clean_slate') {
      var startsAt
      var endsAt
      if (
        vm.dataChecklist2 !== undefined &&
        vm.dataChecklist2 !== '' &&
        vm.dataChecklist2 !== null
      ) {
        if (isDate(vm.dataChecklist2)) {
          startsAt = new Date(vm.dataChecklist2).toISOString()
        } else {
          startsAt = new Date().toISOString()
        }
      } else {
        startsAt = new Date().toISOString()
      }
      if (
        vm.dataChecklist3 !== undefined &&
        vm.dataChecklist3 !== '' &&
        vm.dataChecklist3 !== null
      ) {
        if (isDate(vm.dataChecklist3)) {
          endsAt = new Date(vm.dataChecklist3).toISOString()
        } else {
          endsAt = ''
        }
      } else {
        endsAt = ''
      }

      var setIds = vm.model.s.map((item) => item.id)
      if (setIds.length === 0 && !vm.model['id-ch']) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var currentId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      if (setIds.length === 1 && vm.model['id-ch']) {
        currentId = parseInt(vm.model['id-ch'])
      }

      let scope = 'sets'
      if (vm.model['id-ch']) {
        scope = 'channels'
      }

      SetsService.createChecklistCleanSlate(
        currentId,
        scope,
        startsAt,
        endsAt,
        vm.valRankMin,
        vm.valRankMax,
        '',
        'simple',
        vm.albumType,
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist2 = null
          vm.dataChecklist3 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Clean slate checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'rank') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      var setIds = vm.model.s.map((item) => item.id)
      if (setIds.length === 0 && !vm.model['id-ch']) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var currentId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      if (setIds.length === 1 && vm.model['id-ch']) {
        currentId = parseInt(vm.model['id-ch'])
      }

      let scope = 'sets'
      if (vm.model['id-ch']) {
        scope = 'channels'
      }

      SetsService.createChecklistRank(
        currentId,
        scope,
        expiredAt,
        'Top',
        vm.rankMin,
        vm.rankMax,
        bundleID,
        '',
        'simple',
        vm.albumType,
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Rank checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'hold') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      var setIds = vm.model.s.map((item) => item.id)
      if (setIds.length === 0 && !vm.model['id-ch']) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var currentId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      if (setIds.length === 1 && vm.model['id-ch']) {
        currentId = parseInt(vm.model['id-ch'])
      }

      let scope = 'sets'
      if (vm.model['id-ch']) {
        scope = 'channels'
      }

      SetsService.createChecklistHold(
        currentId,
        scope,
        expiredAt,
        bundleID,
        '',
        '',
        '',
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += "<h3>Hold 'Em checklist created</h3><br />"
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.filterBundleID = false
  vm.clickBundleId = function () {
    if (vm.filterBundleID) {
      vm.filterBundleID = false
      $rootScope.bundleType = ''
    } else {
      vm.filterBundleID = true
      $rootScope.bundleType = 'bundle'
    }
  }
}
